import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Types } from '@grandvisionhq/graphql';
import { OrderConfirmDonation } from '../OrderConfirmDonation/OrderConfirmDonation.js';
import { OrderCallToActionContainer } from '../../../modules/OrderCallToAction/containers/OrderCallToActionContainer.js';

const OrderConfirmHeroBanner = ({ labels , contains , orderNumber , paymentStatus , paymentMethod , donationIntent  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-hero-banner"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-hero-banner__content"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.title), paymentStatus == 'PENDING' && paymentMethod == Types.OrderPaymentMethod.MOBILEPAY ? /*#__PURE__*/ React.createElement(Alert, {
        type: "warning",
        title: labels.orderPending.title,
        message: labels.orderPending.message
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", null, labels.completed, orderNumber && /*#__PURE__*/ React.createElement("strong", null, " ", orderNumber)), /*#__PURE__*/ React.createElement(Alert, {
        type: "success",
        title: labels.orderPlaced.title,
        message: labels.orderPlaced.message
    }), donationIntent && /*#__PURE__*/ React.createElement(OrderConfirmDonation, {
        foundationKey: donationIntent.foundationKey
    })), contains.prescriptionGlasses && /*#__PURE__*/ React.createElement("p", null, labels.orderContainsPrescriptionGlasses), contains.regular && /*#__PURE__*/ React.createElement("p", null, labels.orderContainsSunglasses), /*#__PURE__*/ React.createElement(OrderCallToActionContainer, {
        isStacked: true
    })));
};

export { OrderConfirmHeroBanner };
//# sourceMappingURL=OrderConfirmHeroBanner.js.map
